import { defineMessages } from '@/i18n'

export const reconciliationMessages = defineMessages({
  en: {
    couldNotLoad: 'Could not load.',
    title: 'Reconciliation',
    intro: 'Aufmaß against the Q1 2026 workbook. Compared by day and by position rather than row by row — the two systems disagree about crew identity (160 crew names in the workbook, 123 in AU, 91 shared after normalising), so a row-level join would top out near 55% and start inventing matches.',
    metres: 'Metres',
    subRevenue: 'SUB revenue',
    rows: 'Rows',
    byPosition: 'By position',
    byWorkingDay: 'By working day',
    withinOnePct: '{within} of {total} within 1%',
    colPosition: 'Position',
    colWorkbook: 'Workbook',
    colDate: 'Date',
    colRows: 'Rows',
    colMetres: 'Metres',
    workbook: 'workbook',
  },
  de: {
    couldNotLoad: 'Konnte nicht geladen werden.',
    title: 'Abgleich',
    intro: 'Aufmaß gegen die Arbeitsmappe Q1 2026. Verglichen nach Tag und nach Position statt Zeile für Zeile — die beiden Systeme sind sich über die Identität der Kolonnen uneinig (160 Kolonnennamen in der Arbeitsmappe, 123 in AU, 91 gemeinsam nach Normalisierung), daher käme ein Abgleich auf Zeilenebene nur auf etwa 55 % und würde anfangen, Treffer zu erfinden.',
    metres: 'Meter',
    subRevenue: 'SUB-Umsatz',
    rows: 'Zeilen',
    byPosition: 'Nach Position',
    byWorkingDay: 'Nach Arbeitstag',
    withinOnePct: '{within} von {total} innerhalb von 1 %',
    colPosition: 'Position',
    colWorkbook: 'Arbeitsmappe',
    colDate: 'Datum',
    colRows: 'Zeilen',
    colMetres: 'Meter',
    workbook: 'Arbeitsmappe',
  },
  cnr: {
    couldNotLoad: 'Nije moguće učitati.',
    title: 'Usklađivanje',
    intro: 'Aufmaß u odnosu na radnu svesku za Q1 2026. Poređenje po danu i po poziciji umjesto red po red — dva sistema se ne slažu oko identiteta kolona (160 naziva kolona u radnoj svesci, 123 u AU, 91 zajednički nakon normalizacije), pa bi spajanje na nivou redova dostiglo najviše oko 55% i počelo da izmišlja poklapanja.',
    metres: 'Metri',
    subRevenue: 'SUB prihod',
    rows: 'Redovi',
    byPosition: 'Po poziciji',
    byWorkingDay: 'Po radnom danu',
    withinOnePct: '{within} od {total} unutar 1%',
    colPosition: 'Pozicija',
    colWorkbook: 'Radna sveska',
    colDate: 'Datum',
    colRows: 'Redovi',
    colMetres: 'Metri',
    workbook: 'radna sveska',
  },
  bs: {
    couldNotLoad: 'Nije moguće učitati.',
    title: 'Usklađivanje',
    intro: 'Aufmaß u odnosu na radnu svesku za Q1 2026. Poređenje po danu i po poziciji umjesto red po red — dva sistema se ne slažu oko identiteta kolona (160 naziva kolona u radnoj svesci, 123 u AU, 91 zajednički nakon normalizacije), pa bi spajanje na nivou redova dostiglo najviše oko 55% i počelo izmišljati poklapanja.',
    metres: 'Metri',
    subRevenue: 'SUB prihod',
    rows: 'Redovi',
    byPosition: 'Po poziciji',
    byWorkingDay: 'Po radnom danu',
    withinOnePct: '{within} od {total} unutar 1%',
    colPosition: 'Pozicija',
    colWorkbook: 'Radna sveska',
    colDate: 'Datum',
    colRows: 'Redovi',
    colMetres: 'Metri',
    workbook: 'radna sveska',
  },
  sr: {
    couldNotLoad: 'Nije moguće učitati.',
    title: 'Usklađivanje',
    intro: 'Aufmaß u odnosu na radnu svesku za Q1 2026. Poređenje po danu i po poziciji umesto red po red — dva sistema se ne slažu oko identiteta kolona (160 naziva kolona u radnoj svesci, 123 u AU, 91 zajednički nakon normalizacije), pa bi spajanje na nivou redova dostiglo najviše oko 55% i počelo da izmišlja poklapanja.',
    metres: 'Metri',
    subRevenue: 'SUB prihod',
    rows: 'Redovi',
    byPosition: 'Po poziciji',
    byWorkingDay: 'Po radnom danu',
    withinOnePct: '{within} od {total} unutar 1%',
    colPosition: 'Pozicija',
    colWorkbook: 'Radna sveska',
    colDate: 'Datum',
    colRows: 'Redovi',
    colMetres: 'Metri',
    workbook: 'radna sveska',
  },
})
